if (customElements.get('fostr-static-product-card') === undefined) {
  class FostrStaticProductCard extends HTMLElement {
    get alt () {
      return this.classList.contains('is-alt')
    }

    set alt (value) {
      if (value) {
        return this.classList.add('is-alt')
      }
      return this.classList.remove('is-alt')
    }

    get video () {
      return this.classList.contains('is-video')
    }

    set video (value) {
      if (value) {
        return this.classList.add('is-video')
      }
      return this.classList.remove('is-video')
    }

    constructor () {
      super()

      // Elements
      this.zoomBtn = this.querySelector('[data-zoom]')
      this.downloadBtn = this.querySelector('[data-download]')
      this.videoBtn = this.querySelector('[data-video]')
      this.mediaContainer = this.querySelector('.media')
      this.videoRendered = false

      // Events
      this.videoBtn?.addEventListener('click', this.onClickVideoBtn.bind(this))
    }

    onClickVideoBtn (event) {
      if (!this.videoRendered) {
        const video = this.mediaContainer.querySelector('iframe')
        if (video) {
          video.setAttribute('src', video.getAttribute('data-src'))
          video.removeAttribute('data-src')
          this.videoRendered = true
        }
      }

      if (!this.videoBtn.classList.contains('is-active')) {
        this.video = true
        this.videoBtn.classList.add('is-active')
      } else {
        this.video = false
        this.videoBtn.classList.remove('is-active')
      }
    }
  }

  customElements.define('fostr-static-product-card', FostrStaticProductCard)
}
